export const environment = {
  production: false,
  dcMaxx: {
    baseUrl: 'http://192.168.240.49:3080',
    authKey: '31eec4fb4a359ec5de13cf631e499588',
    dcoSiteId: 1,
    datatype: 1,
  },
  elevation: {
    baseUrl: 'https://egi-api.epiphanex.com',
    authKey: 'ccbb33b9c6cac7cfed4ba4bfece56df4',
    dcoSiteId: 1,
    datatype: 1,
  },
};


